import { StoredSignatureEntry } from "src/app/storage/models/stored-orders/stored-signature-entry";

/**
 * An instance of the StoredSignatureEntry model to be used for schema validation
 */
export const storedSignatureEntryInstance: StoredSignatureEntry = {
	Signature: new File([], ""),
	Timestamp: new Date()
}